import 'jquery-validation';
import 'jquery-validation/dist/additional-methods.js';
import 'jquery-validation-unobtrusive';
import 'jquery-ajax-unobtrusive';
import './pageloading.js';

$.validator.setDefaults({
    errorClass: "input-validation-error",
    highlight: function (element, errorClass) {
        var element = $(element);
        element.addClass(errorClass);
        element.closest('.input').addClass('has-error');
    },
    unhighlight: function (element, errorClass) {
        var element = $(element);
        element.removeClass(errorClass);
        element.closest('.input').removeClass('has-error');        
    },
    submitHandler: function (form) {
        if ($(form).valid()) {
            addPageLoading();
            return true;
        }
    }
});